import { TermProgramInfoModel } from '../../../views/term_courses/models/term_program_info_model';
import { ITerm } from '../../../interfaces/scheduler_interfaces';
import { IQuery } from 'core-ts-types';
import { Query } from 'utility-ng-kernel';

interface ISchedulerActiveTermQueryResult {
  name?: ITerm['name'];
  id?: ITerm['id'];
}

export class SchedulerActiveTermQuery implements IQuery {
  private queryResult: ISchedulerActiveTermQueryResult;

  constructor(private ngTermProgramInfoModel: TermProgramInfoModel) {
    Query.registerQuery(this, ngTermProgramInfoModel);
  }

  run() {
    const activeTerm = this.ngTermProgramInfoModel.read().term;
    if (!activeTerm) {
      this.queryResult = {};
      return this;
    }
    this.queryResult = {
      name: activeTerm.name,
      id: activeTerm.id
    };

    return this;
  }

  get result() {
    return this.queryResult;
  }
}

angular.module('capability-ng-scheduler').service('ngSchedulerActiveTermQuery', SchedulerActiveTermQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/scheduler_active_term/queries/scheduler_active_term_query/scheduler_active_term_query.ts